import * as React from 'react'

import { subscribeToScoreEvents } from '../utils/commentScoreSessionManager'

export const useScoreSessionSync = (
  channelId: string,
  startSession: () => void,
  stopSession: () => void,
): void => {
  React.useEffect(() => {
    const unsubscribe = subscribeToScoreEvents({
      onStart: (id) => id === channelId && startSession(),
      onStop: (id) => id === channelId && stopSession(),
    })
    return unsubscribe
  }, [channelId, startSession, stopSession])
}
